import { Grid, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { TALKIATRY_PHONE_NUMBER_DISPLAY } from '../../../helpers/const';
import UndoInsuranceTermination from './undo-insurance-termination';
import { AssessmentCard, AssessmentHeader } from '../shared';

const OONProviderTermination = () => (
  <>
    <AssessmentHeader title="Sorry, we don’t take your insurance" />
    <AssessmentCard>
      <Typography paragraph>
        Unfortunately, we don't take your insurance.
      </Typography>
      <Typography paragraph>
        We're only able to see patients whose insurance we accept, but we hope
        to be able to meet your needs in the future.
      </Typography>
      <Typography>
        Questions? Give us a call at {TALKIATRY_PHONE_NUMBER_DISPLAY}.
      </Typography>
    </AssessmentCard>
    <Grid container spacing={1} direction="row" sx={{ mt: 1 }}>
      <Grid item xs={12} sm="auto">
        <UndoInsuranceTermination />
      </Grid>
      <Grid item xs={12} sm="auto">
        <LoadingButton
          fullWidth
          size="large"
          variant="outlined"
          href="https://www.talkiatry.com/"
        >
          Return home
        </LoadingButton>
      </Grid>
    </Grid>
  </>
);

export default OONProviderTermination;
